import React from 'react';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';
import StaticPageLayout from '../components/layout/StaticPageLayout';
import { Button, Badge, Card } from '../components/ui';
import SEO from '../components/SEO';
import {
    ACH_PRICE,
    CREDIT_CARD_PRICE,
    DEBIT_CARD_PRICE,
    ACH_SERVICE_FEE,
    DEBIT_CARD_SERVICE_FEE,
    CREDIT_CARD_SERVICE_FEE,
} from '../config';

const plans = [
    {
        name: 'ACH / eCheck',
        price: Number(ACH_PRICE).toFixed(2),
        serviceFee: ACH_SERVICE_FEE,
        features: [
            'Direct bank transfer',
            'Lowest cost option',
            'Automatic renewal processing',
            'Email & SMS notifications',
            'Dedicated customer support',
        ],
    },
    {
        name: 'Debit Card',
        price: Number(DEBIT_CARD_PRICE).toFixed(2),
        serviceFee: DEBIT_CARD_SERVICE_FEE,
        popular: true,
        features: [
            'Use your existing debit card',
            'Fast, convenient payment',
            'Automatic renewal processing',
            'Email & SMS notifications',
            'Dedicated customer support',
        ],
    },
    {
        name: 'Credit Card',
        price: Number(CREDIT_CARD_PRICE).toFixed(2),
        serviceFee: CREDIT_CARD_SERVICE_FEE,
        features: [
            'All major credit cards accepted',
            'Earn card rewards on payments',
            'Automatic renewal processing',
            'Email & SMS notifications',
            'Dedicated customer support',
        ],
    },
];

const Pricing = () => {
    return (
        <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <SEO
                title="Pricing"
                description="RMT vehicle tag renewal pricing: ACH/eCheck from $5.00, debit cards from $5.50, credit cards from $6.50 + 1.75%. No hidden fees. Pay only when we renew."
                canonical="/pricing"
            />
            <Header />
            <StaticPageLayout
                title="Simple, Transparent Pricing"
                subtitle="Choose the payment method that works best for you. All plans include the same great service."
            >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-max-w-5xl">
                    {plans.map((plan, idx) => (
                        <Card
                            key={idx}
                            variant="outlined"
                            className={`tw-relative tw-flex tw-flex-col ${plan.popular ? 'tw-border-primary-500 tw-border-2 tw-shadow-lg tw-shadow-primary-100' : ''}`}
                        >
                            {plan.popular && (
                                <div className="tw-absolute -tw-top-3 tw-left-1/2 -tw-translate-x-1/2">
                                    <Badge variant="primary">Most Popular</Badge>
                                </div>
                            )}

                            <div className="tw-text-center tw-mb-6">
                                <h3 className="tw-text-xl tw-text-gray-900 tw-m-0 tw-mb-4">{plan.name}</h3>
                                <div className="tw-flex tw-items-baseline tw-justify-center tw-gap-1">
                                    <span className="tw-text-4xl tw-font-bold tw-text-gray-900">${plan.price}</span>
                                    <span className="tw-text-sm tw-text-gray-500">/vehicle/renewal</span>
                                </div>
                                {plan.serviceFee > 0 && (
                                    <p className="tw-text-xs tw-text-gray-400 tw-mt-2 tw-m-0">
                                        +{Number(plan.serviceFee).toFixed(2)}% service fee
                                    </p>
                                )}
                            </div>

                            <ul className="tw-list-none tw-p-0 tw-m-0 tw-space-y-3 tw-flex-1">
                                {plan.features.map((feature, fIdx) => (
                                    <li key={fIdx} className="tw-flex tw-items-start tw-gap-2.5">
                                        <svg className="tw-w-5 tw-h-5 tw-text-accent-500 tw-flex-shrink-0 tw-mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                        <span className="tw-text-sm tw-text-gray-600">{feature}</span>
                                    </li>
                                ))}
                            </ul>

                            <div className="tw-mt-6">
                                <Button
                                    variant={plan.popular ? 'primary' : 'secondary'}
                                    to="/"
                                    className="tw-w-full"
                                >
                                    Sign Up
                                </Button>
                            </div>
                        </Card>
                    ))}
                </div>
            </StaticPageLayout>
            <PublicFooter />
        </div>
    );
};

export default Pricing;
